import { Paper } from '@mui/material';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const CustomPaper = styled(Paper)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '1.7rem',
  margin: '4vh 0',
}));

/**
 * HomeTitle component which wraps the native paper component of mui
 * @param { element } children  - The mui component that has to be passed
 * @param { string } padding - paper padding
 * @param { string } width - paper width
 */

const HomeTitle = ({ children, padding, width }) => {
  return (
    <CustomPaper sx={{ padding: padding, width: width }}>
      {children}
    </CustomPaper>
  );
};

export default HomeTitle;

HomeTitle.propTypes = {
  children: PropTypes.element.isRequired,
  padding: PropTypes.string,
  width: PropTypes.string,
};
